import type {
  Consequence_Bool_Exp,
  GetConsequenceCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetConsequenceCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

type ConsequenceCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path. Empty/absent ⇒
  // no entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Consequence_Bool_Exp;
};

export const useGetConsequenceCount = createQueryHook<
  ConsequenceCountArgs,
  number,
  GetConsequenceCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.consequence.consequenceCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    consequence_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetConsequenceCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
